import { createQueryBuilderStore } from './createQueryBuilderStore';
import { QueryBuilderContext } from './QueryBuilderStoreContext';

interface QueryBuilderStoreProviderProps {
  children: React.ReactNode;
}

export const QueryBuilderStoreProvider = ({
  children,
}: QueryBuilderStoreProviderProps) => {
  return (
    <QueryBuilderContext.Provider createStore={createQueryBuilderStore}>
      {children}
    </QueryBuilderContext.Provider>
  );
};
